module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-300italic.60cb254.eot";